// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: hidden;
}

.card-css-mobile {
  padding: 12% !important;
  margin-top: 20px !important;
}

.test-for-fix {
  z-index: 1000;
  background-color: white;
  box-shadow: wheat;
}

.demologo1 {
  height: 100px;
  max-width: 1px;
}

.header1-padding {
  margin-top: 8px;
}

.acc-style-1 {
  width: auto;
  height: auto;
  background-color: #dfe1e2;
}

.acc-style-2 {
  font-size: 4.75em;
}

.acc-style-3 {
  display: inline-block;
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  padding-left: 20px;
}

.hr-line {
  color: #575050;
  margin-top: 0;
}

.header2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 8.4vw;
}

.row {
  margin-top: -6px;
}

.nav-links {
  list-style: none;
}
.nav-links > li {
  display: inline-block;
  padding: 0px 10px;
}
.nav-links > li > a {
  transition: all 0.3s ease 0s;
  list-style: none;
  position: relative;
  cursor: pointer;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande", "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  font-size: 0.93rem;
  line-height: 0.9;
  color: #1d5992;
}
.nav-links > li > a::after {
  content: "";
  color: rgb(73, 37, 195);
  position: absolute;
  left: 0;
  bottom: -0.3rem;
  height: 3px;
  width: 100%;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease-in-out;
}
.nav-links > li > a:hover {
  color: rgb(65, 13, 236);
}
.nav-links > li > a:hover::after {
  content: "";
  color: rgb(65, 13, 236);
  color: #1d5992;
  position: absolute;
  left: 0;
  bottom: -0.3rem;
  height: 3px;
  width: 100%;
  transform: scaleX(1);
}

.mainmenu:hover > .submenu1 {
  opacity: 1;
}

.submenu1 {
  position: absolute;
  width: 500px;
  background-color: rgb(206, 206, 204);
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.1254901961);
  margin-top: 5px;
  opacity: 0;
  z-index: 999;
  transition: 0.5s;
  padding: 0;
  border-radius: 5px;
}

.submenu1 li {
  list-style-type: none;
  padding: 10px;
}

.submenu1 li a {
  font-size: 17px;
  font-family: Lato, sans-serif;
  font-weight: 400;
}

.submenu1 li:hover {
  background-color: #ddd;
  border-radius: 5px;
}

.c-img {
  height: 550px;
  object-fit: cover;
}

.corousel-content {
  color: white;
}

.ep-subtopic {
  font-size: 24px;
  font-family: Lato, sans-serif;
  margin-left: 40px;
  margin-top: 10px;
}

.ep-view-contant {
  color: #1c7ed8;
  margin-top: -60px;
}

.ep-view-contant:hover {
  color: black;
}

.admin-cards {
  margin-left: 0;
}

.admin-card-mobile {
  padding: 200px 200px;
}

.sl-ep-card-content {
  font-family: Merriweather Web, Georgia, Cambria, Times New Roman, Times, serif;
  font-size: 1.22rem;
  line-height: 1.2;
  margin: 0;
}

.admin-cards {
  align-content: center;
  text-align: center;
  margin-top: -200px;
}

.card {
  background-color: #dcddd8;
}

.card1 {
  background-color: #0f3252;
}

.card1:hover {
  background-color: #0f3252;
}

.btn-blue-submit {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-size: 1.06rem;
  line-height: 0.9;
  color: #fff;
  background-color: #005ea2;
  appearance: none;
  border: 0;
  border-radius: 0.25rem;
  cursor: pointer;
  display: inline-block;
  font-weight: 650;
  padding: 0.75rem 1.25rem;
  text-align: center;
  text-decoration: none;
}

.btn-blue-submit:hover {
  background-color: #0f3252;
}

.align {
  margin-bottom: 10% !important;
}

.carouselText {
  font-size: 25px;
}

.align-css-1 {
  text-align: left;
  margin-left: 11.6px;
}

.leftalign {
  margin-left: 3.6% !important;
  margin-bottom: 5% !important;
}

.align-css-2 {
  text-align: left;
}

li,
a,
button {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: rgb(6, 34, 59);
  text-decoration: none;
}

.logo1 {
  height: 100px;
  width: 100px;
  cursor: pointer;
  margin-left: 50px;
}

.new-style-head {
  font-family: Lato, sans-serif;
}

.language-button:hover {
  background-color: rgb(40, 42, 163);
}

.header1 {
  position: absolute;
  right: 100px;
  padding: 50px;
  margin-top: 10px;
}

.btn-blue {
  background-color: rgb(44, 61, 92);
  color: #fff;
  outline: none;
}
.btn-blue:hover {
  background-color: rgb(64, 76, 199);
  color: #fff;
  outline: none;
  box-shadow: 0px 0px 8px rgb(79, 90, 208);
}

.top-row {
  background-color: #d6d6d6;
  padding: 0px 16px 5px 16px;
  display: flex;
}
.top-row > img {
  width: 21px;
  height: 21px;
  border-radius: 50%;
}
.top-row > p {
  font-family: "Abhaya Libre", serif;
  color: #575050;
  font-size: 14px;
  padding-top: 2px;
  padding-left: 5px;
  margin-bottom: 0px;
}
.top-row > p > a {
  font-family: "Abhaya Libre", serif;
  color: #1c7ed8;
  font-size: 14px;
}
.top-row > p > a:hover {
  text-decoration: underline;
}

.content-topic {
  background-color: #1c63a6;
  min-height: 100px;
  width: 100%;
  padding-bottom: 20px;
  margin-left: -1%;
}

.font-style-public-p {
  font-family: Lato, sans-serif;
  text-align: justify;
  color: #505252;
  font-weight: 400;
  font-size: 1rem;
  line-height: 24px;
}

.content-use-of-terms {
  margin-top: 50px;
}

.content-body-top {
  margin-top: 50px;
}

.public-style-content-subtopic {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding: 10px 11vw;
  list-style: none;
  margin-left: -1%;
}

.public-style-content-subtopic li a {
  font-family: Lato, sans-serif;
  color: #ccecf2;
}

.topic-style-public {
  padding: 10px 10vw;
  font-weight: 900;
  font-size: 3rem;
  font-family: Lato, sans-serif;
  color: #ccecf2;
}

.logo-style {
  font-size: 45px;
}

.new {
  list-style: none;
  margin-left: 65px;
  margin-top: 42px;
}

.dot-remove-style {
  list-style: none;
}

.content-body-top {
  margin-top: 50px;
}

.extra {
  font-size: 27px;
}

.feedback-blue-submit {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-size: 1.06rem;
  line-height: 0.9;
  color: #fff;
  background-color: #005ea2;
  appearance: none;
  border: 0;
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  font-weight: 700;
  padding: 0.75rem 1.25rem;
  text-align: center;
  text-decoration: none;
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: 40%;
}

.feedback-blue-submit:hover {
  background-color: #0f3252;
}

li,
a,
button {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: rgb(6, 34, 59);
  text-decoration: none;
}

.navButton {
  color: #1c62a6;
  font-weight: 600;
}
.navButton:hover {
  color: #125599;
}

.logo1 {
  height: 100px;
  width: 100px;
  cursor: pointer;
  margin-left: 50px;
}

.language-button:hover {
  background-color: rgb(40, 42, 163);
}

.header1 {
  position: absolute;
  right: 100px;
  padding: 50px;
  margin-top: 10px;
}

.btn-blue {
  background-color: rgb(44, 61, 92);
  color: #fff;
  outline: none;
}
.btn-blue:hover {
  background-color: rgb(64, 76, 199);
  color: #fff;
  outline: none;
  box-shadow: 0px 0px 8px rgb(79, 90, 208);
}

.top-row {
  background-color: #dfe1e2;
  padding: 0px 16px 5px 16px;
  display: flex;
}
.top-row > img {
  width: 21px;
  height: 21px;
  border-radius: 50%;
}
.top-row > p {
  font-family: "Abhaya Libre", serif;
  color: #575050;
  font-size: 14px;
  padding-top: 2px;
  padding-left: 5px;
  margin-bottom: 0px;
}
.top-row > p > a {
  font-family: "Abhaya Libre", serif;
  color: #1c7ed8;
  font-size: 14px;
}
.top-row > p > a:hover {
  text-decoration: underline;
}

.mainmenu:hover > .submenu1 {
  display: block;
}

.submenu1 {
  position: absolute;
  width: auto;
  background-color: #ffffff;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.1254901961);
  margin-top: 0;
  padding-top: 5px;
  display: none;
  z-index: 999;
  transition: 0.5s;
  padding: 0;
  border-radius: 5px;
}

.submenu1 li {
  list-style-type: none;
  padding: 0;
}

.submenu1 li a {
  font-size: 17px;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 0.93rem;
  padding: 10px;
  display: block;
}

.submenu1 li:hover {
  background-color: rgb(206, 206, 204);
  border-radius: 5px;
}

.content-body-top {
  margin-top: 50px;
}

.extra {
  font-size: 27px;
}

.contact-01 {
  margin-left: 137px;
}

.cnt-style {
  font-family: "Montserrat", sans-serif;
}

.recent-css {
  color: white;
  font-family: Lato, sans-serif;
}

.card-cs {
  position: unset;
  margin: 0 10px;
}

.block-btn {
  display: block;
  text-align: center;
  margin: 20px auto 0;
}

.card-main {
  margin: 10px;
  background-color: #dcddd8;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.card-main .card {
  border: none;
}

.m-t-10 {
  margin-top: 10px;
}

.search-tsx {
  padding-left: 15%;
  margin-left: -15%;
}

.list-group {
  width: auto;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.1254901961);
  margin-top: 0;
  padding-top: 5px;
  z-index: 999;
  transition: 0.5s;
  padding: 0;
  border-radius: 5px;
  margin-top: 10px;
}

.newcss {
  position: absolute;
}

.newcss2 {
  position: absolute;
  width: 50%;
}

.desc-css {
  text-decoration: underline;
  list-style: none;
  line-height: 2.6;
  margin-left: 6.9%;
}

.Onging-css {
  color: blue;
}

.closed-css {
  color: red;
}

@media only screen and (max-width: 500px) {
  .test-for-fix {
    z-index: 1000;
    background-color: white;
    box-shadow: wheat;
  }
  .card-css-mobile {
    margin-top: 100px !important;
  }
  .header-sl {
    max-width: 500px;
  }
  .demologo1 {
    height: 100px;
    max-width: 1px;
  }
  .header1-padding {
    margin-top: 8px;
  }
  .acc-style-1 {
    width: auto;
    height: auto;
    background-color: #dfe1e2;
  }
  .acc-style-2 {
    font-size: 4.75em;
  }
  .acc-style-3 {
    display: inline-block;
    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
    padding-left: 20px;
  }
  .hr-line {
    color: #575050;
    margin-top: 0;
  }
  .header2 {
    padding: 10px 10.5vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 8.4vw;
  }
  .row {
    margin-top: -6px;
  }
  .nav-links {
    list-style: none;
  }
  .nav-links > li {
    display: inline-block;
    padding: 0px 10px;
  }
  .nav-links > li > a {
    transition: all 0.3s ease 0s;
    list-style: none;
    position: relative;
    cursor: pointer;
    font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande", "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
    font-size: 0.93rem;
    line-height: 0.9;
    color: #1d5992;
  }
  .nav-links > li > a::after {
    content: "";
    color: rgb(73, 37, 195);
    position: absolute;
    left: 0;
    bottom: -0.3rem;
    height: 3px;
    width: 100%;
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease-in-out;
  }
  .nav-links > li > a:hover {
    color: rgb(65, 13, 236);
  }
  .nav-links > li > a:hover::after {
    content: "";
    color: rgb(65, 13, 236);
    color: #1d5992;
    position: absolute;
    left: 0;
    bottom: -0.3rem;
    height: 3px;
    width: 100%;
    transform: scaleX(1);
  }
  .mainmenu:hover > .submenu1 {
    opacity: 1;
  }
  .submenu1 {
    position: absolute;
    width: 500px;
    background-color: rgb(206, 206, 204);
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.1254901961);
    margin-top: 5px;
    opacity: 0;
    z-index: 999;
    transition: 0.5s;
    padding: 0;
    border-radius: 5px;
  }
  .submenu1 li {
    list-style-type: none;
    padding: 10px;
  }
  .submenu1 li a {
    font-size: 17px;
    font-family: Lato, sans-serif;
    font-weight: 400;
  }
  .submenu1 li:hover {
    background-color: #ddd;
    border-radius: 5px;
  }
  .c-img {
    height: 550px;
    object-fit: cover;
  }
  .corousel-content {
    color: white;
  }
  .ep-subtopic {
    font-size: 24px;
    font-family: Lato, sans-serif;
    margin-left: 40px;
    margin-top: 10px;
  }
  .ep-view-contant {
    color: #1c7ed8;
    margin-top: -60px;
  }
  .ep-view-contant:hover {
    color: black;
  }
  .admin-cards {
    margin-left: 0;
  }
  .admin-card-mobile {
    padding: 200px 20px;
  }
  .sl-ep-card-content {
    font-family: Merriweather Web, Georgia, Cambria, Times New Roman, Times, serif;
    font-size: 1.22rem;
    line-height: 1.2;
    margin: 0;
  }
  .admin-cards {
    align-content: center;
    text-align: center;
    margin-top: -200px;
  }
  .card {
    background-color: #dcddd8;
  }
  .card1 {
    background-color: #0f3252;
  }
  .card1:hover {
    background-color: #0f3252;
  }
  .btn-blue-submit {
    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
    font-size: 1.06rem;
    line-height: 0.9;
    color: #fff;
    background-color: #005ea2;
    appearance: none;
    border: 0;
    border-radius: 0.25rem;
    cursor: pointer;
    display: inline-block;
    font-weight: 650;
    padding: 0.75rem 1.25rem;
    text-align: center;
    text-decoration: none;
  }
  .btn-blue-submit:hover {
    background-color: #0f3252;
  }
  .carouselText {
    font-size: 25px;
  }
  li,
  a,
  button {
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: rgb(6, 34, 59);
    text-decoration: none;
  }
  .logo1 {
    height: 100px;
    width: 100px;
    cursor: pointer;
    margin-left: 50px;
  }
  .new-style-head {
    font-family: Lato, sans-serif;
  }
  .language-button:hover {
    background-color: rgb(40, 42, 163);
  }
  .header1 {
    position: absolute;
    right: 100px;
    padding: 50px;
    margin-top: 10px;
  }
  .btn-blue {
    background-color: rgb(44, 61, 92);
    color: #fff;
    outline: none;
  }
  .btn-blue:hover {
    background-color: rgb(64, 76, 199);
    color: #fff;
    outline: none;
    box-shadow: 0px 0px 8px rgb(79, 90, 208);
  }
  .top-row {
    background-color: #d6d6d6;
    padding: 0px 16px 5px 16px;
    display: flex;
  }
  .top-row > img {
    width: 21px;
    height: 21px;
    border-radius: 50%;
  }
  .top-row > p {
    font-family: "Abhaya Libre", serif;
    color: #575050;
    font-size: 14px;
    padding-top: 2px;
    padding-left: 5px;
    margin-bottom: 0px;
  }
  .top-row > p > a {
    font-family: "Abhaya Libre", serif;
    color: #1c7ed8;
    font-size: 14px;
  }
  .top-row > p > a:hover {
    text-decoration: underline;
  }
  .content-topic {
    background-color: #1c63a6;
    min-height: 100px;
    width: 100%;
    padding-bottom: 20px;
    margin-left: -1%;
  }
  .font-style-public-p {
    font-family: Lato, sans-serif;
    text-align: justify;
    color: #505252;
    font-weight: 400;
    font-size: 1rem;
    line-height: 24px;
  }
  .content-use-of-terms {
    margin-top: 50px;
  }
  .content-body-top {
    margin-top: 50px;
  }
  .public-style-content-subtopic {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    padding: 10px 11vw;
    list-style: none;
    margin-left: -1%;
  }
  .public-style-content-subtopic li a {
    font-family: Lato, sans-serif;
    color: #ccecf2;
  }
  .topic-style-public {
    padding: 10px 10vw;
    font-weight: 900;
    font-size: 3rem;
    font-family: Lato, sans-serif;
    color: #ccecf2;
  }
  .logo-style {
    font-size: 45px;
  }
  .new {
    list-style: none;
    margin-left: 65px;
    margin-top: 42px;
  }
  .dot-remove-style {
    list-style: none;
  }
  .content-body-top {
    margin-top: 50px;
  }
  .extra {
    font-size: 27px;
  }
  li,
  a,
  button {
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: rgb(6, 34, 59);
    text-decoration: none;
  }
  .navButton {
    color: #1c62a6;
    font-weight: 600;
  }
  .navButton:hover {
    color: #125599;
  }
  .logo1 {
    height: 100px;
    width: 100px;
    cursor: pointer;
    margin-left: 50px;
  }
  .language-button:hover {
    background-color: rgb(40, 42, 163);
  }
  .header1 {
    position: absolute;
    right: 100px;
    padding: 50px;
    margin-top: 10px;
  }
  .btn-blue {
    background-color: rgb(44, 61, 92);
    color: #fff;
    outline: none;
  }
  .btn-blue:hover {
    background-color: rgb(64, 76, 199);
    color: #fff;
    outline: none;
    box-shadow: 0px 0px 8px rgb(79, 90, 208);
  }
  .top-row {
    background-color: #dfe1e2;
    padding: 0px 16px 5px 16px;
    display: flex;
  }
  .top-row > img {
    width: 21px;
    height: 21px;
    border-radius: 50%;
  }
  .top-row > p {
    font-family: "Abhaya Libre", serif;
    color: #575050;
    font-size: 14px;
    padding-top: 2px;
    padding-left: 5px;
    margin-bottom: 0px;
  }
  .top-row > p > a {
    font-family: "Abhaya Libre", serif;
    color: #1c7ed8;
    font-size: 14px;
  }
  .top-row > p > a:hover {
    text-decoration: underline;
  }
  .mainmenu:hover > .submenu1 {
    display: block;
  }
  .submenu1 {
    position: absolute;
    width: auto;
    background-color: #ffffff;
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.1254901961);
    margin-top: 0;
    padding-top: 5px;
    display: none;
    z-index: 999;
    transition: 0.5s;
    padding: 0;
    border-radius: 5px;
  }
  .submenu1 li {
    list-style-type: none;
    padding: 0;
  }
  .submenu1 li a {
    font-size: 17px;
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    font-size: 0.93rem;
    padding: 10px;
    display: block;
  }
  .submenu1 li:hover {
    background-color: rgb(206, 206, 204);
    border-radius: 5px;
  }
  .content-body-top {
    margin-top: 50px;
  }
  .extra {
    font-size: 27px;
  }
  .contact-01 {
    margin-left: 137px;
  }
  .cnt-style {
    font-family: "Montserrat", sans-serif;
  }
  .recent-css {
    color: white;
    font-family: Lato, sans-serif;
  }
  .card-cs {
    position: unset;
    margin: 0 10px;
  }
  .block-btn {
    display: block;
    text-align: center;
    margin: 20px auto 0;
  }
  .card-main {
    margin: 10px;
    background-color: #dcddd8;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  .card-main .card {
    border: none;
  }
  .m-t-10 {
    margin-top: 10px;
  }
  .search-tsx {
    padding-left: 15%;
    margin-left: -15%;
  }
  .list-group {
    position: absolute;
    width: auto;
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.1254901961);
    margin-top: 0;
    padding-top: 5px;
    z-index: 999;
    transition: 0.5s;
    padding: 0;
    border-radius: 5px;
    margin-top: 10px;
  }
  .desc-css {
    text-decoration: underline;
    list-style: none;
    line-height: 2.6;
    margin-left: 6.9%;
  }
  .ongoing-end {
    justify-content: flex-end !important;
  }
  .Onging-css {
    color: blue;
  }
  .closed-css {
    color: red;
  }
}
/* Example of a media query for mobile devices */
@media only screen and (max-width: 767px) {
  /* Styles for mobile devices */
  .admin-cards {
    margin-top: -35%;
  }
}
/* Base styles for smaller screens */
/* Media query for tablets */
@media only screen and (min-width: 600px) {
  /* Tablet styles */
  .admin-cards {
    margin-top: -13%;
  }
}
@media only screen and (min-width: 580px) {
  /* Tablet styles */
  .admin-cards {
    margin-top: -13%;
  }
}
/* Media query for desktops */
@media only screen and (min-width: 1024px) {
  /* Desktop styles */
}
@media (max-width: 767px) {
  .card1 {
    max-width: 24rem;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Home.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;AAAF;;AAEA;EACA,uBAAA;EACA,2BAAA;AACA;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,qBAAA;EACA,sFAAA;EAEA,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;AAAF;;AASA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,gBAAA;AANF;AAQE;EACE,qBAAA;EACA,iBAAA;AANJ;AAQI;EACE,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,sHAAA;EAEA,kBAAA;EACA,gBAAA;EACA,cAAA;AAPN;AAQM;EACE,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,wBAAA;EACA,sCAAA;AANR;AASM;EACE,uBAAA;AAPR;AAUM;EACE,WAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;AARR;;AAgBA;EACE,UAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,mDAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,qBAAA;EACA,aAAA;AAbF;;AAgBA;EAEE,eAAA;EACA,6BAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,sBAAA;EACA,kBAAA;AAdF;;AAkBA;EACE,aAAA;EACA,iBAAA;AAfF;;AAmBA;EACE,YAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,YAAA;AAhBF;;AAmBA;EACE,cAAA;AAhBF;;AAmBA;EACE,oBAAA;AAhBF;;AAmBA;EACE,8EAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AAhBF;;AAmBA;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,yBAAA;AAhBF;;AAmBA;EACE,yBAAA;AAhBF;;AAmBA;EACE,yBAAA;AAhBF;;AAmBA;EACE,sFAAA;EAEA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EAEA,gBAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,6BAAA;AAjBF;;AAmBA;EACE,eAAA;AAhBF;;AAmBA;EACA,gBAAA;EACA,mBAAA;AAhBA;;AAmBA;EACE,4BAAA;EACA,4BAAA;AAhBF;;AAmBA;EACA,gBAAA;AAhBA;;AAoBA;;;EAGE,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,6BAAA;AAjBF;;AAoBA;EACE,kCAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,iCAAA;EACA,WAAA;EACA,aAAA;AAjBF;AAmBE;EACE,kCAAA;EACA,WAAA;EACA,aAAA;EACA,wCAAA;AAjBJ;;AAqBA;EACE,yBAAA;EACA,0BAAA;EACA,aAAA;AAlBF;AAoBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAnBJ;AAqBI;EACE,kCAAA;EACA,cAAA;EACA,eAAA;AAnBN;AAqBM;EACE,0BAAA;AAnBR;;AA2BA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;AAxBF;;AA0BA;EACE,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAvBF;;AA0BA;EACE,gBAAA;AAvBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,6BAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,eAAA;AAzBF;;AA4BA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,sFAAA;EAEA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EAEA,gBAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,yBAAA;AA5BF;;AAgCA;;;EAGE,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;AA7BF;;AAgCA;EACE,cAAA;EACA,gBAAA;AA7BF;AA+BE;EACE,cAAA;AA7BJ;;AAiCA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA9BF;;AAkCA;EACE,kCAAA;AA/BF;;AAkCA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AA/BF;;AAkCA;EACE,iCAAA;EACA,WAAA;EACA,aAAA;AA/BF;AAiCE;EACE,kCAAA;EACA,WAAA;EACA,aAAA;EACA,wCAAA;AA/BJ;;AAmCA;EACE,yBAAA;EACA,0BAAA;EACA,aAAA;AAhCF;AAkCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAhCJ;AAmCE;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAjCJ;AAmCI;EACE,kCAAA;EACA,cAAA;EACA,eAAA;AAjCN;AAmCM;EACE,0BAAA;AAjCR;;AAyCA;EACE,cAAA;AAtCF;;AAyCA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mDAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AAtCF;;AAyCA;EACE,qBAAA;EACA,UAAA;AAtCF;;AAyCA;EAEE,eAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAvCF;;AA0CA;EACE,oCAAA;EACA,kBAAA;AAvCF;;AA4CA;EACE,gBAAA;AAzCF;;AA4CA;EACE,eAAA;AAzCF;;AA8CA;EACE,kBAAA;AA3CF;;AA8CA;EACE,qCAAA;AA3CF;;AA+CA;EACE,YAAA;EACA,6BAAA;AA5CF;;AA+CA;EACE,eAAA;EACA,cAAA;AA5CF;;AA+CA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AA5CF;;AA+CA;EACE,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AA5CF;;AA+CA;EACE,YAAA;AA5CF;;AA8CA;EACE,gBAAA;AA3CF;;AA8CA;EACE,iBAAA;EACA,iBAAA;AA3CF;;AA8CA;EAEE,WAAA;EACA,mDAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AA5CF;;AA+CA;EACE,kBAAA;AA5CF;;AA+CA;EACE,kBAAA;EACA,UAAA;AA5CF;;AA+CA;EACE,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AA5CF;;AAgDA;EACE,WAAA;AA7CF;;AA+CA;EACE,UAAA;AA5CF;;AA+CA;EACE;IACE,aAAA;IACA,uBAAA;IACA,iBAAA;EA5CF;EA8CA;IACE,4BAAA;EA5CF;EA+CA;IACE,gBAAA;EA7CF;EAgDA;IACE,aAAA;IACA,cAAA;EA9CF;EAiDA;IACE,eAAA;EA/CF;EAkDA;IACE,WAAA;IACA,YAAA;IACA,yBAAA;EAhDF;EAmDA;IACE,iBAAA;EAjDF;EAoDA;IACE,qBAAA;IACA,sFAAA;IAEA,kBAAA;EAnDF;EAsDA;IACE,cAAA;IACA,aAAA;EApDF;EAuDA;IAIE,oBAAA;IAGA,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,mBAAA;EA3DF;EA8DA;IACE,gBAAA;EAtDF;EAyDA;IACE,gBAAA;EAvDF;EAyDE;IACE,qBAAA;IACA,iBAAA;EAvDJ;EAyDI;IACE,4BAAA;IACA,gBAAA;IACA,kBAAA;IACA,eAAA;IACA,sHAAA;IAEA,kBAAA;IACA,gBAAA;IACA,cAAA;EAxDN;EAyDM;IACE,WAAA;IACA,uBAAA;IACA,kBAAA;IACA,OAAA;IACA,eAAA;IACA,WAAA;IACA,WAAA;IACA,oBAAA;IACA,wBAAA;IACA,sCAAA;EAvDR;EA0DM;IACE,uBAAA;EAxDR;EA2DM;IACE,WAAA;IACA,uBAAA;IACA,cAAA;IACA,kBAAA;IACA,OAAA;IACA,eAAA;IACA,WAAA;IACA,WAAA;IACA,oBAAA;EAzDR;EAiEA;IACE,UAAA;EA/DF;EAkEA;IACE,kBAAA;IACA,YAAA;IACA,oCAAA;IACA,mDAAA;IACA,eAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,kBAAA;EAhEF;EAmEA;IACE,qBAAA;IACA,aAAA;EAjEF;EAoEA;IAEE,eAAA;IACA,6BAAA;IACA,gBAAA;EAnEF;EAsEA;IACE,sBAAA;IACA,kBAAA;EApEF;EAwEA;IACE,aAAA;IACA,iBAAA;EAtEF;EA0EA;IACE,YAAA;EAxEF;EA2EA;IACE,eAAA;IACA,6BAAA;IACA,iBAAA;IACA,gBAAA;EAzEF;EA4EA;IACE,cAAA;IACA,iBAAA;EA1EF;EA6EA;IACE,YAAA;EA3EF;EA8EA;IACE,cAAA;EA5EF;EA+EA;IACE,mBAAA;EA7EF;EAgFA;IACE,8EAAA;IACA,kBAAA;IACA,gBAAA;IACA,SAAA;EA9EF;EAiFA;IACE,qBAAA;IACA,kBAAA;IACA,kBAAA;EA/EF;EAkFA;IACE,yBAAA;EAhFF;EAmFA;IACE,yBAAA;EAjFF;EAoFA;IACE,yBAAA;EAlFF;EAqFA;IACE,sFAAA;IAEA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,yBAAA;IAEA,gBAAA;IACA,SAAA;IACA,sBAAA;IACA,eAAA;IACA,qBAAA;IACA,gBAAA;IACA,wBAAA;IACA,kBAAA;IACA,qBAAA;EApFF;EAuFA;IACE,yBAAA;EArFF;EAuFA;IACE,eAAA;EArFF;EAyFA;;;IAGE,qCAAA;IACA,gBAAA;IACA,eAAA;IACA,qBAAA;IACA,qBAAA;EAvFF;EA0FA;IACE,aAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAxFF;EA2FA;IACE,6BAAA;EAzFF;EA4FA;IACE,kCAAA;EA1FF;EA6FA;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EA3FF;EA8FA;IACE,iCAAA;IACA,WAAA;IACA,aAAA;EA5FF;EA8FE;IACE,kCAAA;IACA,WAAA;IACA,aAAA;IACA,wCAAA;EA5FJ;EAgGA;IACE,yBAAA;IACA,0BAAA;IACA,aAAA;EA9FF;EAgGE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EA9FJ;EAiGE;IACE,kCAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EA/FJ;EAiGI;IACE,kCAAA;IACA,cAAA;IACA,eAAA;EA/FN;EAiGM;IACE,0BAAA;EA/FR;EAuGA;IACE,yBAAA;IACA,iBAAA;IACA,WAAA;IACA,oBAAA;IACA,gBAAA;EArGF;EAuGA;IACE,6BAAA;IACA,mBAAA;IACA,cAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EArGF;EAwGA;IACE,gBAAA;EAtGF;EA2GA;IACE,gBAAA;EAzGF;EA4GA;IACE,aAAA;IACA,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;EA1GF;EA6GA;IACE,6BAAA;IACA,cAAA;EA3GF;EA8GA;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,6BAAA;IACA,cAAA;EA5GF;EA+GA;IACE,eAAA;EA7GF;EAgHA;IACE,gBAAA;IACA,iBAAA;IACA,gBAAA;EA9GF;EAiHA;IACE,gBAAA;EA/GF;EAoHA;IACE,gBAAA;EAlHF;EAqHA;IACE,eAAA;EAnHF;EAuHA;;;IAGE,qCAAA;IACA,gBAAA;IACA,eAAA;IACA,qBAAA;IACA,qBAAA;EArHF;EAwHA;IACE,cAAA;IACA,gBAAA;EAtHF;EAwHE;IACE,cAAA;EAtHJ;EA0HA;IACE,aAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAxHF;EA4HA;IACE,kCAAA;EA1HF;EA6HA;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EA3HF;EA8HA;IACE,iCAAA;IACA,WAAA;IACA,aAAA;EA5HF;EA8HE;IACE,kCAAA;IACA,WAAA;IACA,aAAA;IACA,wCAAA;EA5HJ;EAgIA;IACE,yBAAA;IACA,0BAAA;IACA,aAAA;EA9HF;EAgIE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EA9HJ;EAiIE;IACE,kCAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EA/HJ;EAiII;IACE,kCAAA;IACA,cAAA;IACA,eAAA;EA/HN;EAiIM;IACE,0BAAA;EA/HR;EAuIA;IACE,cAAA;EArIF;EAwIA;IACE,kBAAA;IACA,WAAA;IACA,yBAAA;IACA,mDAAA;IACA,aAAA;IACA,gBAAA;IACA,aAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,kBAAA;EAtIF;EAyIA;IACE,qBAAA;IACA,UAAA;EAvIF;EA0IA;IAEE,eAAA;IACA,qCAAA;IACA,gBAAA;IACA,kBAAA;IACA,aAAA;IACA,cAAA;EAzIF;EA4IA;IACE,oCAAA;IACA,kBAAA;EA1IF;EA+IA;IACE,gBAAA;EA7IF;EAgJA;IACE,eAAA;EA9IF;EAmJA;IACE,kBAAA;EAjJF;EAoJA;IACE,qCAAA;EAlJF;EAsJA;IACE,YAAA;IACA,6BAAA;EApJF;EAuJA;IACE,eAAA;IACA,cAAA;EArJF;EAwJA;IACE,cAAA;IACA,kBAAA;IACA,mBAAA;EAtJF;EAyJA;IACE,YAAA;IACA,yBAAA;IACA,sBAAA;IACA,kBAAA;EAvJF;EA0JA;IACE,YAAA;EAxJF;EA0JA;IACE,gBAAA;EAxJF;EA2JA;IACE,iBAAA;IACA,iBAAA;EAzJF;EA4JA;IACE,kBAAA;IACA,WAAA;IACA,mDAAA;IACA,aAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,kBAAA;IACA,gBAAA;EA1JF;EA6JA;IACE,0BAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;EA3JF;EA+JF;IACE,oCAAA;EA7JA;EAgKA;IACE,WAAA;EA9JF;EAgKA;IACE,UAAA;EA9JF;AACF;AAyKA,gDAAA;AACA;EACE,8BAAA;EACA;IACE,gBAAA;EAvKF;AACF;AA4KA,oCAAA;AAEA,4BAAA;AACA;EACE,kBAAA;EACA;IACE,gBAAA;EA3KF;AACF;AA8KA;EACE,kBAAA;EACA;IACE,gBAAA;EA5KF;AACF;AA+KA,6BAAA;AACA;EACE,mBAAA;AA7KF;AAmLA;EACE;IACE,gBAAA;IACA,WAAA;EAjLF;AACF","sourcesContent":["// Header STYLE\nbody{\n  overflow-x: hidden;\n}\n.card-css-mobile{\npadding: 12% !important;\nmargin-top: 20px !important;\n\n}\n.test-for-fix {\n  z-index: 1000;\n  background-color: white;\n  box-shadow: wheat;\n}\n\n.demologo1 {\n  height: 100px;\n  max-width: 1px;\n}\n\n.header1-padding {\n  margin-top: 8px;\n}\n\n.acc-style-1 {\n  width: auto;\n  height: auto;\n  background-color: #dfe1e2;\n}\n\n.acc-style-2 {\n  font-size: 4.75em;\n}\n\n.acc-style-3 {\n  display: inline-block;\n  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n    sans-serif;\n  padding-left: 20px;\n}\n\n.hr-line {\n  color: #575050;\n  margin-top: 0;\n}\n\n// .header2 {\n//   display: flex;\n//   justify-content: space-between;\n//   align-items: center;\n//   padding: 10px 10.5vw;\n// }\n.header2 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 8.4vw;\n}\n\n.row {\n  margin-top: -6px;\n}\n\n.nav-links {\n  list-style: none;\n\n  > li {\n    display: inline-block;\n    padding: 0px 10px;\n\n    > a {\n      transition: all 0.3s ease 0s;\n      list-style: none;\n      position: relative;\n      cursor: pointer;\n      font-family: \"Lucida Sans\", \"Lucida Sans Regular\", \"Lucida Grande\",\n        \"Lucida Sans Unicode\", Geneva, Verdana, sans-serif;\n      font-size: 0.93rem;\n      line-height: 0.9;\n      color: #1d5992;\n      &::after {\n        content: \"\";\n        color: rgb(73, 37, 195);\n        position: absolute;\n        left: 0;\n        bottom: -0.3rem;\n        height: 3px;\n        width: 100%;\n        transform: scaleX(0);\n        transform-origin: center;\n        transition: transform 0.3s ease-in-out;\n      }\n\n      &:hover {\n        color: rgb(65, 13, 236);\n      }\n\n      &:hover::after {\n        content: \"\";\n        color: rgb(65, 13, 236);\n        color: #1d5992;\n        position: absolute;\n        left: 0;\n        bottom: -0.3rem;\n        height: 3px;\n        width: 100%;\n        transform: scaleX(1);\n      }\n    }\n  }\n}\n\n//submenu CSS\n\n.mainmenu:hover > .submenu1 {\n  opacity: 1;\n}\n\n.submenu1 {\n  position: absolute;\n  width: 500px;\n  background-color: rgb(206, 206, 204);\n  box-shadow: 0 20px 45px #00000020;\n  margin-top: 5px;\n  opacity: 0;\n  z-index: 999;\n  transition: 0.5s;\n  padding: 0;\n  border-radius: 5px;\n}\n\n.submenu1 li {\n  list-style-type: none;\n  padding: 10px;\n}\n\n.submenu1 li a {\n  // font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n  font-size: 17px;\n  font-family: Lato, sans-serif;\n  font-weight: 400;\n}\n\n.submenu1 li:hover {\n  background-color: #ddd;\n  border-radius: 5px;\n}\n\n//Home Style\n.c-img {\n  height: 550px;\n  object-fit: cover;\n  // filter: brightness(0.6);\n}\n\n.corousel-content {\n  color: white;\n}\n\n.ep-subtopic {\n  font-size: 24px;\n  font-family: Lato, sans-serif;\n  margin-left: 40px;\n  margin-top: 10px;\n}\n\n.ep-view-contant {\n  color: #1c7ed8;\n  margin-top: -60px;\n}\n\n.ep-view-contant:hover {\n  color: black;\n}\n\n.admin-cards {\n  margin-left: 0;\n}\n\n.admin-card-mobile{\n  padding: 200px 200px;\n}\n\n.sl-ep-card-content {\n  font-family: Merriweather Web, Georgia, Cambria, Times New Roman, Times, serif;\n  font-size: 1.22rem;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.admin-cards {\n  align-content: center;\n  text-align: center;\n  margin-top: -200px;\n}\n\n.card {\n  background-color: #dcddd8;\n}\n\n.card1 {\n  background-color: #0f3252;\n}\n\n.card1:hover {\n  background-color: #0f3252;\n}\n\n.btn-blue-submit {\n  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n    sans-serif;\n  font-size: 1.06rem;\n  line-height: 0.9;\n  color: #fff;\n  background-color: #005ea2;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  display: inline-block;\n  font-weight: 650;\n  padding: 0.75rem 1.25rem;\n  text-align: center;\n  text-decoration: none;\n}\n\n.btn-blue-submit:hover {\n  background-color: #0f3252;\n}\n\n.align{\n  margin-bottom: 10% !important;\n}\n.carouselText {\n  font-size: 25px;\n}\n\n.align-css-1{\ntext-align: left;\nmargin-left: 11.6px;\n}\n\n.leftalign{\n  margin-left: 3.6% !important;\n  margin-bottom: 5% !important;\n}\n\n.align-css-2{\ntext-align: left;\n}\n\n//NEW STYLE IMPORT\nli,\na,\nbutton {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgb(6, 34, 59);\n  text-decoration: none;\n}\n\n.logo1 {\n  height: 100px;\n  width: 100px;\n  cursor: pointer;\n  margin-left: 50px;\n}\n\n.new-style-head {\n  font-family: Lato, sans-serif;\n}\n\n.language-button:hover {\n  background-color: rgb(40, 42, 163);\n}\n\n.header1 {\n  position: absolute;\n  right: 100px;\n  padding: 50px;\n  margin-top: 10px;\n}\n\n.btn-blue {\n  background-color: rgb(44, 61, 92);\n  color: #fff;\n  outline: none;\n\n  &:hover {\n    background-color: rgb(64, 76, 199);\n    color: #fff;\n    outline: none;\n    box-shadow: 0px 0px 8px rgb(79, 90, 208);\n  }\n}\n\n.top-row {\n  background-color: #d6d6d6;\n  padding: 0px 16px 5px 16px;\n  display: flex;\n\n  > img {\n    width: 21px;\n    height: 21px;\n    border-radius: 50%;\n  }\n\n  > p {\n    font-family: \"Abhaya Libre\", serif;\n    color: #575050;\n    font-size: 14px;\n    padding-top: 2px;\n    padding-left: 5px;\n    margin-bottom: 0px;\n\n    > a {\n      font-family: \"Abhaya Libre\", serif;\n      color: #1c7ed8;\n      font-size: 14px;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n//terms of use CSS\n\n.content-topic {\n  background-color: #1c63a6;\n  min-height: 100px;\n  width: 100%;\n  padding-bottom: 20px;\n  margin-left: -1%;\n}\n.font-style-public-p {\n  font-family: Lato, sans-serif;\n  text-align: justify;\n  color: #505252;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 24px;\n}\n\n.content-use-of-terms {\n  margin-top: 50px;\n}\n\n//terms of participation css\n\n.content-body-top {\n  margin-top: 50px;\n}\n\n.public-style-content-subtopic {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  padding: 10px 11vw;\n  list-style: none;\n  margin-left: -1%;\n}\n\n.public-style-content-subtopic li a {\n  font-family: Lato, sans-serif;\n  color: #ccecf2;\n}\n\n.topic-style-public {\n  padding: 10px 10vw;\n  font-weight: 900;\n  font-size: 3rem;\n  font-family: Lato, sans-serif;\n  color: #ccecf2;\n}\n\n.logo-style {\n  font-size: 45px;\n}\n\n.new {\n  list-style: none;\n  margin-left: 65px;\n  margin-top: 42px;\n}\n\n.dot-remove-style {\n  list-style: none;\n}\n\n//FAQS CSS\n\n.content-body-top {\n  margin-top: 50px;\n}\n\n.extra {\n  font-size: 27px;\n}\n\n.feedback-blue-submit {\n  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n    sans-serif;\n  font-size: 1.06rem;\n  line-height: 0.9;\n  color: #fff;\n  background-color: #005ea2;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  display: flex;\n  font-weight: 700;\n  padding: 0.75rem 1.25rem;\n  text-align: center;\n  text-decoration: none;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  margin-left: 40%;\n}\n\n.feedback-blue-submit:hover {\n  background-color: #0f3252;\n}\n\n// new css for final project\nli,\na,\nbutton {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgb(6, 34, 59);\n  text-decoration: none;\n}\n\n.navButton {\n  color: #1c62a6;\n  font-weight: 600;\n\n  &:hover {\n    color: #125599;\n  }\n}\n\n.logo1 {\n  height: 100px;\n  width: 100px;\n  cursor: pointer;\n  margin-left: 50px;\n}\n// new test css for header\n\n.language-button:hover {\n  background-color: rgb(40, 42, 163);\n}\n\n.header1 {\n  position: absolute;\n  right: 100px;\n  padding: 50px;\n  margin-top: 10px;\n}\n\n.btn-blue {\n  background-color: rgb(44, 61, 92);\n  color: #fff;\n  outline: none;\n\n  &:hover {\n    background-color: rgb(64, 76, 199);\n    color: #fff;\n    outline: none;\n    box-shadow: 0px 0px 8px rgb(79, 90, 208);\n  }\n}\n\n.top-row {\n  background-color: #dfe1e2;\n  padding: 0px 16px 5px 16px;\n  display: flex;\n\n  > img {\n    width: 21px;\n    height: 21px;\n    border-radius: 50%;\n  }\n\n  > p {\n    font-family: \"Abhaya Libre\", serif;\n    color: #575050;\n    font-size: 14px;\n    padding-top: 2px;\n    padding-left: 5px;\n    margin-bottom: 0px;\n\n    > a {\n      font-family: \"Abhaya Libre\", serif;\n      color: #1c7ed8;\n      font-size: 14px;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n//submenu css\n\n.mainmenu:hover > .submenu1 {\n  display: block;\n}\n\n.submenu1 {\n  position: absolute;\n  width: auto;\n  background-color: #ffffff;\n  box-shadow: 0 20px 45px #00000020;\n  margin-top: 0;\n  padding-top: 5px;\n  display: none;\n  z-index: 999;\n  transition: 0.5s;\n  padding: 0;\n  border-radius: 5px;\n}\n\n.submenu1 li {\n  list-style-type: none;\n  padding: 0;\n}\n\n.submenu1 li a {\n  //font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n  font-size: 17px;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 400;\n  font-size: 0.93rem;\n  padding: 10px;\n  display: block;\n}\n\n.submenu1 li:hover {\n  background-color: rgb(206, 206, 204);\n  border-radius: 5px;\n}\n\n//FAQS CSS\n\n.content-body-top {\n  margin-top: 50px;\n}\n\n.extra {\n  font-size: 27px;\n}\n\n//contact us\n\n.contact-01 {\n  margin-left: 137px;\n}\n\n.cnt-style {\n  font-family: \"Montserrat\", sans-serif;\n}\n\n//recent css\n.recent-css {\n  color: white;\n  font-family: Lato, sans-serif;\n}\n\n.card-cs {\n  position: unset;\n  margin: 0 10px;\n}\n\n.block-btn {\n  display: block;\n  text-align: center;\n  margin: 20px auto 0;\n}\n\n.card-main {\n  margin: 10px;\n  background-color: #dcddd8;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n\n.card-main .card {\n  border: none;\n}\n.m-t-10 {\n  margin-top: 10px;\n}\n\n.search-tsx {\n  padding-left: 15%;\n  margin-left: -15%;\n}\n\n.list-group {\n  // position: absolute;\n  width: auto;\n  box-shadow: 0 20px 45px #00000020;\n  margin-top: 0;\n  padding-top: 5px;\n  z-index: 999;\n  transition: 0.5s;\n  padding: 0;\n  border-radius: 5px;\n  margin-top: 10px;\n}\n\n.newcss {\n  position:absolute;\n}\n\n.newcss2{\n  position: absolute;\n  width: 50%;\n}\n\n.desc-css {\n  text-decoration: underline;\n  list-style: none;\n  line-height: 2.6;\n  margin-left: 6.9%;\n}\n\n//New CSS\n.Onging-css {\n  color: blue;\n}\n.closed-css {\n  color: red;\n}\n//Mobile responsive\n@media only screen and (max-width: 500px) {\n  .test-for-fix {\n    z-index: 1000;\n    background-color: white;\n    box-shadow: wheat;\n  }\n  .card-css-mobile{\n    margin-top: 100px !important;\n  }\n\n  .header-sl{\n    max-width: 500px;\n  }\n\n  .demologo1 {\n    height: 100px;\n    max-width: 1px;\n  }\n\n  .header1-padding {\n    margin-top: 8px;\n  }\n\n  .acc-style-1 {\n    width: auto;\n    height: auto;\n    background-color: #dfe1e2;\n  }\n\n  .acc-style-2 {\n    font-size: 4.75em;\n  }\n\n  .acc-style-3 {\n    display: inline-block;\n    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n      sans-serif;\n    padding-left: 20px;\n  }\n\n  .hr-line {\n    color: #575050;\n    margin-top: 0;\n  }\n\n  .header2 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 10.5vw;\n  }\n  .header2 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 8.4vw;\n  }\n\n  .row {\n    margin-top: -6px;\n  }\n\n  .nav-links {\n    list-style: none;\n\n    > li {\n      display: inline-block;\n      padding: 0px 10px;\n\n      > a {\n        transition: all 0.3s ease 0s;\n        list-style: none;\n        position: relative;\n        cursor: pointer;\n        font-family: \"Lucida Sans\", \"Lucida Sans Regular\", \"Lucida Grande\",\n          \"Lucida Sans Unicode\", Geneva, Verdana, sans-serif;\n        font-size: 0.93rem;\n        line-height: 0.9;\n        color: #1d5992;\n        &::after {\n          content: \"\";\n          color: rgb(73, 37, 195);\n          position: absolute;\n          left: 0;\n          bottom: -0.3rem;\n          height: 3px;\n          width: 100%;\n          transform: scaleX(0);\n          transform-origin: center;\n          transition: transform 0.3s ease-in-out;\n        }\n\n        &:hover {\n          color: rgb(65, 13, 236);\n        }\n\n        &:hover::after {\n          content: \"\";\n          color: rgb(65, 13, 236);\n          color: #1d5992;\n          position: absolute;\n          left: 0;\n          bottom: -0.3rem;\n          height: 3px;\n          width: 100%;\n          transform: scaleX(1);\n        }\n      }\n    }\n  }\n\n  //submenu CSS\n\n  .mainmenu:hover > .submenu1 {\n    opacity: 1;\n  }\n\n  .submenu1 {\n    position: absolute;\n    width: 500px;\n    background-color: rgb(206, 206, 204);\n    box-shadow: 0 20px 45px #00000020;\n    margin-top: 5px;\n    opacity: 0;\n    z-index: 999;\n    transition: 0.5s;\n    padding: 0;\n    border-radius: 5px;\n  }\n\n  .submenu1 li {\n    list-style-type: none;\n    padding: 10px;\n  }\n\n  .submenu1 li a {\n    // font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n    font-size: 17px;\n    font-family: Lato, sans-serif;\n    font-weight: 400;\n  }\n\n  .submenu1 li:hover {\n    background-color: #ddd;\n    border-radius: 5px;\n  }\n\n  //Home Style\n  .c-img {\n    height: 550px;\n    object-fit: cover;\n    // filter: brightness(0.6);\n  }\n\n  .corousel-content {\n    color: white;\n  }\n\n  .ep-subtopic {\n    font-size: 24px;\n    font-family: Lato, sans-serif;\n    margin-left: 40px;\n    margin-top: 10px;\n  }\n\n  .ep-view-contant {\n    color: #1c7ed8;\n    margin-top: -60px;\n  }\n\n  .ep-view-contant:hover {\n    color: black;\n  }\n\n  .admin-cards {\n    margin-left: 0;\n  }\n\n  .admin-card-mobile{\n    padding: 200px 20px;\n  }\n\n  .sl-ep-card-content {\n    font-family: Merriweather Web, Georgia, Cambria, Times New Roman, Times, serif;\n    font-size: 1.22rem;\n    line-height: 1.2;\n    margin: 0;\n  }\n\n  .admin-cards {\n    align-content: center;\n    text-align: center;\n    margin-top: -200px;\n  }\n\n  .card {\n    background-color: #dcddd8;\n  }\n\n  .card1 {\n    background-color: #0f3252;\n  }\n\n  .card1:hover {\n    background-color: #0f3252;\n  }\n\n  .btn-blue-submit {\n    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n      sans-serif;\n    font-size: 1.06rem;\n    line-height: 0.9;\n    color: #fff;\n    background-color: #005ea2;\n    -moz-appearance: none;\n    appearance: none;\n    border: 0;\n    border-radius: 0.25rem;\n    cursor: pointer;\n    display: inline-block;\n    font-weight: 650;\n    padding: 0.75rem 1.25rem;\n    text-align: center;\n    text-decoration: none;\n  }\n\n  .btn-blue-submit:hover {\n    background-color: #0f3252;\n  }\n  .carouselText {\n    font-size: 25px;\n  }\n\n  //NEW STYLE IMPORT\n  li,\n  a,\n  button {\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    color: rgb(6, 34, 59);\n    text-decoration: none;\n  }\n\n  .logo1 {\n    height: 100px;\n    width: 100px;\n    cursor: pointer;\n    margin-left: 50px;\n  }\n\n  .new-style-head {\n    font-family: Lato, sans-serif;\n  }\n\n  .language-button:hover {\n    background-color: rgb(40, 42, 163);\n  }\n\n  .header1 {\n    position: absolute;\n    right: 100px;\n    padding: 50px;\n    margin-top: 10px;\n  }\n\n  .btn-blue {\n    background-color: rgb(44, 61, 92);\n    color: #fff;\n    outline: none;\n\n    &:hover {\n      background-color: rgb(64, 76, 199);\n      color: #fff;\n      outline: none;\n      box-shadow: 0px 0px 8px rgb(79, 90, 208);\n    }\n  }\n\n  .top-row {\n    background-color: #d6d6d6;\n    padding: 0px 16px 5px 16px;\n    display: flex;\n\n    > img {\n      width: 21px;\n      height: 21px;\n      border-radius: 50%;\n    }\n\n    > p {\n      font-family: \"Abhaya Libre\", serif;\n      color: #575050;\n      font-size: 14px;\n      padding-top: 2px;\n      padding-left: 5px;\n      margin-bottom: 0px;\n\n      > a {\n        font-family: \"Abhaya Libre\", serif;\n        color: #1c7ed8;\n        font-size: 14px;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  //terms of use CSS\n\n  .content-topic {\n    background-color: #1c63a6;\n    min-height: 100px;\n    width: 100%;\n    padding-bottom: 20px;\n    margin-left: -1%;\n  }\n  .font-style-public-p {\n    font-family: Lato, sans-serif;\n    text-align: justify;\n    color: #505252;\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 24px;\n  }\n\n  .content-use-of-terms {\n    margin-top: 50px;\n  }\n\n  //terms of participation css\n\n  .content-body-top {\n    margin-top: 50px;\n  }\n\n  .public-style-content-subtopic {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    padding: 10px 11vw;\n    list-style: none;\n    margin-left: -1%;\n  }\n\n  .public-style-content-subtopic li a {\n    font-family: Lato, sans-serif;\n    color: #ccecf2;\n  }\n\n  .topic-style-public {\n    padding: 10px 10vw;\n    font-weight: 900;\n    font-size: 3rem;\n    font-family: Lato, sans-serif;\n    color: #ccecf2;\n  }\n\n  .logo-style {\n    font-size: 45px;\n  }\n\n  .new {\n    list-style: none;\n    margin-left: 65px;\n    margin-top: 42px;\n  }\n\n  .dot-remove-style {\n    list-style: none;\n  }\n\n  //FAQS CSS\n\n  .content-body-top {\n    margin-top: 50px;\n  }\n\n  .extra {\n    font-size: 27px;\n  }\n\n  // new css for final project\n  li,\n  a,\n  button {\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    color: rgb(6, 34, 59);\n    text-decoration: none;\n  }\n\n  .navButton {\n    color: #1c62a6;\n    font-weight: 600;\n\n    &:hover {\n      color: #125599;\n    }\n  }\n\n  .logo1 {\n    height: 100px;\n    width: 100px;\n    cursor: pointer;\n    margin-left: 50px;\n  }\n  // new test css for header\n\n  .language-button:hover {\n    background-color: rgb(40, 42, 163);\n  }\n\n  .header1 {\n    position: absolute;\n    right: 100px;\n    padding: 50px;\n    margin-top: 10px;\n  }\n\n  .btn-blue {\n    background-color: rgb(44, 61, 92);\n    color: #fff;\n    outline: none;\n\n    &:hover {\n      background-color: rgb(64, 76, 199);\n      color: #fff;\n      outline: none;\n      box-shadow: 0px 0px 8px rgb(79, 90, 208);\n    }\n  }\n\n  .top-row {\n    background-color: #dfe1e2;\n    padding: 0px 16px 5px 16px;\n    display: flex;\n\n    > img {\n      width: 21px;\n      height: 21px;\n      border-radius: 50%;\n    }\n\n    > p {\n      font-family: \"Abhaya Libre\", serif;\n      color: #575050;\n      font-size: 14px;\n      padding-top: 2px;\n      padding-left: 5px;\n      margin-bottom: 0px;\n\n      > a {\n        font-family: \"Abhaya Libre\", serif;\n        color: #1c7ed8;\n        font-size: 14px;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  //submenu css\n\n  .mainmenu:hover > .submenu1 {\n    display: block;\n  }\n\n  .submenu1 {\n    position: absolute;\n    width: auto;\n    background-color: #ffffff;\n    box-shadow: 0 20px 45px #00000020;\n    margin-top: 0;\n    padding-top: 5px;\n    display: none;\n    z-index: 999;\n    transition: 0.5s;\n    padding: 0;\n    border-radius: 5px;\n  }\n\n  .submenu1 li {\n    list-style-type: none;\n    padding: 0;\n  }\n\n  .submenu1 li a {\n    //font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n    font-size: 17px;\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 400;\n    font-size: 0.93rem;\n    padding: 10px;\n    display: block;\n  }\n\n  .submenu1 li:hover {\n    background-color: rgb(206, 206, 204);\n    border-radius: 5px;\n  }\n\n  //FAQS CSS\n\n  .content-body-top {\n    margin-top: 50px;\n  }\n\n  .extra {\n    font-size: 27px;\n  }\n\n  //contact us\n\n  .contact-01 {\n    margin-left: 137px;\n  }\n\n  .cnt-style {\n    font-family: \"Montserrat\", sans-serif;\n  }\n\n  //recent css\n  .recent-css {\n    color: white;\n    font-family: Lato, sans-serif;\n  }\n\n  .card-cs {\n    position: unset;\n    margin: 0 10px;\n  }\n\n  .block-btn {\n    display: block;\n    text-align: center;\n    margin: 20px auto 0;\n  }\n\n  .card-main {\n    margin: 10px;\n    background-color: #dcddd8;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n  }\n\n  .card-main .card {\n    border: none;\n  }\n  .m-t-10 {\n    margin-top: 10px;\n  }\n\n  .search-tsx {\n    padding-left: 15%;\n    margin-left: -15%;\n  }\n\n  .list-group {\n    position: absolute;\n    width: auto;\n    box-shadow: 0 20px 45px #00000020;\n    margin-top: 0;\n    padding-top: 5px;\n    z-index: 999;\n    transition: 0.5s;\n    padding: 0;\n    border-radius: 5px;\n    margin-top: 10px;\n  }\n\n  .desc-css {\n    text-decoration: underline;\n    list-style: none;\n    line-height: 2.6;\n    margin-left: 6.9%;\n  }\n\n  //New CSS\n.ongoing-end{\n  justify-content: flex-end !important;\n  \n}\n  .Onging-css {\n    color: blue;\n  }\n  .closed-css {\n    color: red;\n  }\n}\n\n// /* Additional styles for larger screens if needed */\n// @media only screen and (max-width: 430px) {\n//   /* Add larger screen-specific styles here */\n//   .admin-cards {\n//     margin-top: -35%;\n//   }\n// }\n\n/* Example of a media query for mobile devices */\n@media only screen and (max-width: 767px) {\n  /* Styles for mobile devices */\n  .admin-cards {\n    margin-top: -35%;\n  }\n\n}\n\n\n/* Base styles for smaller screens */\n\n/* Media query for tablets */\n@media only screen and (min-width: 600px) {\n  /* Tablet styles */\n  .admin-cards {\n    margin-top: -13%;\n  }\n}\n\n@media only screen and (min-width: 580px) {\n  /* Tablet styles */\n  .admin-cards {\n    margin-top: -13%;\n  }\n}\n\n/* Media query for desktops */\n@media only screen and (min-width: 1024px) {\n  /* Desktop styles */\n  // .admin-cards {\n  //   // margin-top: -35%;\n  // }\n}\n//card css for mobile view\n@media (max-width: 767px) {\n  .card1{\n    max-width: 24rem;\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
